import React from 'react';

import { EchoDlg } from '../app/components/echo-dlg';
import { ExistingApplicationDlg } from '../features/account/dialogs/existing-application-dlg';
import { UserWithEmailAndPhoneExistsDlg } from '../features/account/dialogs/user-with-email-and-phone-exists';
import { UserWithEmailExistsDlg } from '../features/account/dialogs/user-with-email-exists';
import { CMRADlg } from '../features/address-verification/dialogs/cmra-dlg/CMRADlg';
import { PostOfficeBoxDlg } from '../features/address-verification/dialogs/post-office-box-dlg';
import { SimilarAddressDlg } from '../features/address-verification/dialogs/similar-address-dlg';
import { UnverifiedAddressDlg } from '../features/address-verification/dialogs/unverified-address-dlg';
import { ResumeApplicationDlg } from '../features/application/dialogs/resume-application-dlg';
import { ConfirmRemoveIndividualDlg } from '../features/application-review/dialogs/confirm-remove-other-individual-dlg';
import { OtherIndividualInfoDlg } from '../features/application-review/dialogs/other-individual-dialog';

type EchoModal = {
  type: 'echo-dlg';
  context: string;
};

type PostOfficeBoxDialogModal = {
  type: 'address-post-office-box';
  context: null;
};

type CMRADialogModal = {
  type: 'address-cmra';
  context: null;
};

type UnverifiedAddressDialogModal = {
  type: 'address-unverified';
  context: React.ComponentProps<typeof UnverifiedAddressDlg>['context'];
};

type SimilarAddressDialogModal = {
  type: 'address-similar';
  context: React.ComponentProps<typeof SimilarAddressDlg>['context'];
};

type ResumeApplicationDialogModal = {
  type: 'resume-application';
  context: null;
};

type OtherIndividualInfoModal = {
  type: 'other-individual-info';
  context: React.ComponentProps<typeof OtherIndividualInfoDlg>['context'];
};

type ConfirmRemoveOtherIndividualModal = {
  type: 'remove-other-individual';
  context: React.ComponentProps<typeof ConfirmRemoveIndividualDlg>['context'];
};

type UserWithEmailAndPhoneExistsModal = {
  type: 'user-with-email-and-phone-exists';
  context: React.ComponentProps<typeof UserWithEmailAndPhoneExistsDlg>['context'];
};

type UserWithEmailExistsModal = {
  type: 'user-with-email-exists';
  context: null;
};
type ExistingApplicationModal = {
  type: 'existing-application';
  context: React.ComponentProps<typeof ExistingApplicationDlg>['context'];
};

export type ModalDlg =
  | ConfirmRemoveOtherIndividualModal
  | CMRADialogModal
  | EchoModal
  | OtherIndividualInfoModal
  | PostOfficeBoxDialogModal
  | ResumeApplicationDialogModal
  | SimilarAddressDialogModal
  | UnverifiedAddressDialogModal
  | UserWithEmailAndPhoneExistsModal
  | UserWithEmailExistsModal
  | ExistingApplicationModal;

type ModalComponent = React.FC<{
  onClose: () => void;
  context: ModalDlg['context'];
}>;

function typedModalDlg<T extends ModalDlg>(
  key: T['type'],
  dlg: React.FC<{ onClose: () => void; context: T['context'] }>,
): ModalComponent {
  return dlg;
}

const modals: Record<ModalDlg['type'], ModalComponent> = {
  'echo-dlg': typedModalDlg<EchoModal>('echo-dlg', EchoDlg),
  'address-post-office-box': typedModalDlg<PostOfficeBoxDialogModal>('address-post-office-box', PostOfficeBoxDlg),
  'address-cmra': typedModalDlg<CMRADialogModal>('address-cmra', CMRADlg),
  'address-unverified': typedModalDlg<UnverifiedAddressDialogModal>('address-unverified', UnverifiedAddressDlg),
  'address-similar': typedModalDlg<SimilarAddressDialogModal>('address-similar', SimilarAddressDlg),
  'resume-application': typedModalDlg<ResumeApplicationDialogModal>('resume-application', ResumeApplicationDlg),
  'other-individual-info': typedModalDlg<OtherIndividualInfoModal>('other-individual-info', OtherIndividualInfoDlg),
  'remove-other-individual': typedModalDlg<ConfirmRemoveOtherIndividualModal>(
    'remove-other-individual',
    ConfirmRemoveIndividualDlg,
  ),
  'user-with-email-and-phone-exists': typedModalDlg<UserWithEmailAndPhoneExistsModal>(
    'user-with-email-and-phone-exists',
    UserWithEmailAndPhoneExistsDlg,
  ),
  'user-with-email-exists': typedModalDlg<UserWithEmailExistsModal>('user-with-email-exists', UserWithEmailExistsDlg),
  'existing-application': typedModalDlg<ExistingApplicationModal>('existing-application', ExistingApplicationDlg),
};

export { modals };
